// Все тексты интерфейса. Английская версия — en.ts с теми же ключами.
export const ru = {
  app: { name: 'МыслиКлаб', tagline: 'Играй в то, что любишь, открывай новое, собирай коллекции' },
  // бонусная валюта — нейроны (решение владельца 14.10.2026); формы для «1 нейрон / 3 нейрона / 15 нейронов»
  currency: { one: 'нейрон', few: 'нейрона', many: 'нейронов', rub: '₽' },
  common: { loading: 'Загрузка…', back: 'Назад', save: 'Сохранить', cancel: 'Отмена', retry: 'Попробовать ещё раз', close: 'Закрыть' },
  home: {
    nextStep: 'Твой следующий шаг',
    soon: 'Первые квесты появятся здесь совсем скоро.',
    guestTitle: 'Начни с квеста',
    guestText: 'Первая глава любого квеста — бесплатно и без регистрации.',
    play: 'Играть как гость',
    login: 'Войти',
    saveProgress: 'Войдите, чтобы прогресс не потерялся',
    profile: 'Профиль',
    quests: 'Квесты',
    classic: 'Классика МыслиКлаба',
  },
  quest: {
    progress: 'Разгадано {n} из {total}',
    hint: 'В каждой игре 7 вопросов и одна скрытая тема: {hint}',
    game: 'Игра {n}',
    points: '{n} очков',
    secret: 'Тема скрыта — разгадайте её по 7 вопросам',
    draft: 'черновик',
  },
  part: {
    main: '① Разгадка', chapter: '② Погружение', bonus: '③ Для фанатов', round: 'Раунд',
    free: 'Бесплатно', paid: 'По подписке или за нейроны', locked: 'Откроется после предыдущей части',
    play: 'Играть', continue: 'Продолжить', done: 'Пройдено',
    buy: 'Открыть за {price}', bought: 'Открыто навсегда', replay: 'Ещё раз · {price}', balance: 'У вас {n}', login: 'Войдите, чтобы открыть',
  },
  play: {
    question: 'Вопрос {n} из {total}', score: '{score} очков', answer: 'Ваш ответ', theme: 'Тема — одним-двумя словами',
    submit: 'Ответить', next: 'Дальше', finish: 'Итог', correct: 'Верно!', wrong: 'Неверно', timeout: 'Время вышло',
    points: '+{points}', rightAnswer: 'Правильный ответ: {answer}', themeOptions: 'Не угадали — выберите тему из вариантов',
  },
  hint: {
    hint: '💡 {name} · {price}', fifty: '50/50', letter: 'Первая буква', theme: 'Первые буквы',
    retry: '🛡 Право на ошибку · {price}', time: '⏱ +{sec} с · {price}',
    fiftyUsed: '💡 50/50 — два неверных варианта убраны', letterUsed: '💡 {mask} · букв: {n}', themeUsed: '💡 Первые буквы: {letters}',
    retryOn: '🛡 Право на ошибку — если ошибётесь, можно ответить ещё раз', retryUsed: '🛡 Неверно — попробуйте ещё раз',
    timeUsed: '⏱ +{sec} с', notEnough: 'Не хватает нейронов: нужно {price}',
  },
  shop: {
    gameText: { quest: 'Купить игру целиком: все части открыты навсегда, без подписки.', classic: 'Купить игру: одно прохождение.' },
    buyGame: 'Купить игру · {price}',
    useNeurons: 'Списать {n} (−{rub})',
    waitTitle: 'Проверяем оплату', waitText: 'Ждём подтверждение банка — обычно несколько секунд.',
    paidTitle: 'Оплата прошла', paidText: 'Игра открыта. Приятной игры!',
    failTitle: 'Оплата не прошла', failText: 'Деньги не списаны. Можно попробовать ещё раз.',
    slowTitle: 'Банк отвечает долго', slowText: 'Как только банк подтвердит оплату, игра откроется сама. Деньги не пропадут.',
    back: 'К игре',
  },
  result: {
    title: 'Итог', themeSolved: 'Вы разгадали тему', themeWas: 'Тема была', score: '{score} из {max} очков',
    correct: 'Верных ответов: {n} из {total}', next: 'Дальше — {part}', needAccount: 'Войдите, чтобы играть дальше и сохранить прогресс',
    review: 'Разбор вопросов', back: 'К игре',
  },
  login: {
    title: 'Вход',
    subtitle: 'Один аккаунт на сайте и в Telegram',
    telegram: 'Через Telegram',
    tgWaiting: 'Откройте бота и нажмите «Подтвердить вход». Мы ждём…',
    tgOpenAgain: 'Открыть бота ещё раз',
    email: 'По почте',
    emailPlaceholder: 'Почта',
    sendCode: 'Получить код',
    codeSent: 'Код отправлен на {email}',
    codePlaceholder: '6 цифр из письма',
    signIn: 'Войти',
    otherEmail: 'Другая почта',
    vk: 'Через VK',
    vkReturning: 'Входим через VK…',
    privacy: 'Почту не показываем другим игрокам.',
  },
  profile: {
    title: 'Профиль',
    nick: 'Ник',
    city: 'Город',
    guest: 'Гость',
    methods: 'Способы входа',
    method: { email: 'Почта', vk: 'VK', telegram: 'Telegram' },
    link: { email: 'Привязать почту', vk: 'Привязать VK', telegram: 'Привязать Telegram' },
    unlink: 'Отвязать',
    unlinkAsk: 'Отвязать {name}? Входить этим способом будет нельзя.',
    merge: 'Объединить',
    linked: 'Готово — способ входа привязан',
    merged: 'Аккаунты объединены — прогресс сложился в один профиль',
    logout: 'Выйти',
    saved: 'Сохранено',
    admin: 'Админка',
  },
  admin: {
    title: 'Админка',
    sources: 'Источники → оплата',
    days: 'За {n} дней',
    cols: { source: 'Источник', visits: 'Пришли', profiles: 'Профили', registered: 'Регистрация', played: 'Играли', paid: 'Оплатили', revenue: 'Выручка' },
    empty: 'Пока пусто',
    tabs: { games: 'Игры', quests: 'Квесты', prices: 'Цены', sources: 'Источники' },
    search: 'Поиск по названию или адресу',
    formats: { all: 'Все', quest: 'Квесты', classic: 'Классика', xxl: 'XXL' },
    statuses: { published: 'Опубликована', draft: 'Черновик', hidden: 'Скрыта' },
    status: 'Статус',
    played: 'начали {started}, прошли {finished}',
    games: 'игр: {n}',
    edit: 'Изменить',
    saved: 'Сохранено',
    questNote: 'Статус квеста меняется вместе со всеми его играми.',
    fields: { title: 'Название', description: 'Описание', difficulty: 'Сложность (1–5)', keep: 'пусто — не менять' },
    pricesRub: 'Цены, рубли',
    pricesNeurons: 'Цены, нейроны',
    neuron: { chapter: '② Погружение', bonus: '③ Для фанатов', replay: 'Повтор', fifty: '50/50', letter: 'Первая буква', theme: 'Буквы темы',
              retry: 'Право на ошибку', time: '+время', time_sec: '+время, секунд' },
    discountPct: 'Скидка нейронами, % цены (до 30)',
  },
  err: {
    network: 'Нет связи. Проверьте интернет',
    server: 'Что-то пошло не так. Попробуйте ещё раз',
    auth: 'Войдите заново',
    auth_expired: 'Откройте приложение заново',
    bad_email: 'Проверьте адрес почты',
    bad_code: 'Неверный или устаревший код',
    too_often: 'Слишком часто. Попробуйте чуть позже',
    email_off: 'Вход по почте скоро появится',
    email_failed: 'Не удалось отправить письмо',
    vk_off: 'Вход через VK скоро появится',
    vk_failed: 'VK не подтвердил вход',
    expired: 'Время истекло — попробуйте ещё раз',
    last_method: 'Это единственный способ входа — сначала привяжите другой',
    both_tg: 'У обоих аккаунтов свой Telegram — объединить нельзя',
    has_tg: 'Telegram уже привязан',
    need_account: 'Войдите, чтобы продолжить',
    bad_nick: 'Ник — от 2 до 40 символов',
    forbidden: 'Нет доступа',
    not_found: 'Не нашли такую игру',
    locked: 'Сначала пройдите предыдущую часть',
    paywall: 'Эта часть открывается по подписке или покупкой',
    already_played: 'Эта часть уже пройдена',
    finished: 'Игра уже завершена',
    not_enough: 'Не хватает нейронов',
    hint_used: 'Подсказка к этому вопросу уже взята',
    already_owned: 'Эта игра у вас уже есть',
    pay_off: 'Оплата картой скоро появится',
    pay_failed: 'Банк не ответил. Попробуйте ещё раз',
    time_used: 'Время к этому вопросу уже добавлено',
    no_hint: 'У этого вопроса подсказки нет',
    not_needed: 'Эта часть у вас уже открыта',
  },
};
